









import {Vue , Component} from 'vue-property-decorator';
import API from '@/Api';
@Component
export default class Appreciation extends Vue {
    public items: any = [];
    public load() {
        API.Instance
        .get('/api/Appreication')
        .then((response) => {
            this.items = response.data;
        });
    }
    public mounted() {
        this.load();
    }
}
